var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailRegex } from '../../../../classes/leads';
import { DomManipulationService } from '../../../../services/dom-manipulation/dom-manipulation.service';
import { RECAPTCHA_SCRIPT } from '../../../../classes/dynamicScripts';
import { HasSubscriptions } from '../../../../components/has-subscriptions';
import { LeadsService } from '../../../../services/leads.service';
import { ErrorService, ErrorKey } from '../../../../services/error.service';
var EmailShareModalComponent = /** @class */ (function (_super) {
    __extends(EmailShareModalComponent, _super);
    function EmailShareModalComponent(domManipulationService, leadService, errorService) {
        var _this = _super.call(this) || this;
        _this.domManipulationService = domManipulationService;
        _this.leadService = leadService;
        _this.errorService = errorService;
        _this.isLuxury = false;
        _this.isCommercial = false;
        _this.fromEmail = '';
        _this.subjectTitle = '';
        _this.submitted = new EventEmitter();
        _this.style = '';
        _this.isLoading = false;
        return _this;
    }
    EmailShareModalComponent.prototype.ngOnInit = function () {
        this.contactForm = new FormGroup({
            email: new FormControl(null, [Validators.required, Validators.pattern(emailRegex)]),
            from: new FormControl(null, Validators.required),
            subject: new FormControl(null, Validators.required),
            listingUrl: new FormControl(null, Validators.required),
            comments: new FormControl(null, Validators.required),
        });
        this.contactForm.controls['from'].setValue(this.fromEmail);
        this.contactForm.controls['subject'].setValue(this.subjectTitle);
        this.contactForm.controls['listingUrl'].setValue(this.url);
        this.contactForm.controls['comments'].setValue(this.description);
        this.style = this.isLuxury ? 'luxury' : '';
    };
    EmailShareModalComponent.prototype.sendGrecaptcha = function () {
        var _this = this;
        this.addSub(this.domManipulationService.loadScript(RECAPTCHA_SCRIPT).subscribe(function () {
            grecaptcha.execute(_this.recaptchaId);
        }));
    };
    EmailShareModalComponent.prototype.getOnSubmit = function () {
        return this.onSubmit.bind(this);
    };
    EmailShareModalComponent.prototype.onSubmit = function (recaptchaKey) {
        var _this = this;
        if (!this.contactForm.valid)
            return;
        var payload = {
            email: this.contactForm.controls['email'].value,
            from: this.contactForm.controls['from'].value,
            subject: this.contactForm.controls['subject'].value,
            message: this.contactForm.controls['comments'].value,
            listingUrl: this.contactForm.controls['listingUrl'].value
        };
        this.isLoading = true;
        this.leadService.shareListing(payload, recaptchaKey)
            .then(function () {
            _this.isLoading = false;
            _this.submitted.emit(false);
        })
            .catch(function (err) {
            _this.isLoading = false;
            _this.errorService.displayError(ErrorKey.lead, err.error.errorCode, 30);
        });
    };
    Object.defineProperty(EmailShareModalComponent.prototype, "from", {
        get: function () { return this.contactForm.controls['from']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailShareModalComponent.prototype, "email", {
        get: function () { return this.contactForm.controls['email']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailShareModalComponent.prototype, "subject", {
        get: function () { return this.contactForm.controls['subject']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailShareModalComponent.prototype, "listingUrl", {
        get: function () { return this.contactForm.controls['listingUrl']; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailShareModalComponent.prototype, "comments", {
        get: function () { return this.contactForm.controls['comments']; },
        enumerable: true,
        configurable: true
    });
    return EmailShareModalComponent;
}(HasSubscriptions));
export { EmailShareModalComponent };
